import React, { useState, useEffect } from 'react';
import { IoMdCloseCircle } from "react-icons/io";
import './enquiry_form.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.mitadtu.in';

const EnquiryForm = ({ isSticky = false }) => {
  const [form, setForm] = useState({
    name: '',
    mobile: '',
    email: '',
    course: '',
    captchaAnswer: ''
  });
  const [courses, setCourses] = useState([]);
  const [captcha, setCaptcha] = useState({ question: '', answer: 0 });
  const [formEnabled, setFormEnabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchFormData();
  }, []);

  const fetchFormData = async () => {
    try {
      const [coursesRes, settingsRes] = await Promise.all([
        fetch(`${API_BASE}/api/enquiries/public/courses`),
        fetch(`${API_BASE}/api/enquiries/public/settings`)
      ]);

      const coursesData = await coursesRes.json();
      const settingsData = await settingsRes.json();

      if (coursesRes.ok) setCourses(coursesData.data || []);
      if (settingsRes.ok) {
        setFormEnabled(settingsData.data.formEnabled);
        setCaptcha(settingsData.data.captcha);
      }
    } catch (err) {
      setError('Failed to load form data');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setError('');
  };

  const validateForm = () => {
    if (!form.name.trim()) return 'Name is required';
    if (!/^[a-zA-Z\s]{2,50}$/.test(form.name)) return 'Invalid name format';

    if (!form.mobile.trim()) return 'Mobile number is required';
    if (!/^[6-9]\d{9}$/.test(form.mobile)) return 'Invalid mobile number';

    if (!form.email.trim()) return 'Email is required';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return 'Invalid email format';

    if (!form.course) return 'Please select a course';
    if (!form.captchaAnswer.trim()) return 'Please solve the security question';

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${API_BASE}/api/enquiries/public/submit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          captchaQuestion: captcha.question
        })
      });

      const data = await res.json();

      if (res.ok) {
        setSuccess(data.message);
        setForm({ name: '', mobile: '', email: '', course: '', captchaAnswer: '' });
        fetchFormData();
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError('Failed to submit enquiry. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!formEnabled) {
    return (
      <div className="enquiry-form-container">
        <div className="form-disabled">
          <h2>Enquiry Form Temporarily Disabled</h2>
          <p>We are currently not accepting new enquiries. Please check back later.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`enquiry-form-container ${isSticky ? 'sticky-version' : ''}`}>
      <div className="enquiry-form-card">
        {!isSticky && (
          <>
            <h2>Course Enquiry Form</h2>
            <p>Fill out the form below and we'll get back to you soon!</p>

          </>
        )}

        {error && <div className="alert error">{error}</div>}
        {success && <div className="alert success">{success}</div>}

        <form onSubmit={handleSubmit} className="enquiry-form">
          <div className="form-group">
            <label>Full Name *</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Enter your full name"
              required
            />
          </div>

          <div className="form-group">
            <label>Mobile Number *</label>
            <input
              type="tel"
              name="mobile"
              value={form.mobile}
              onChange={handleChange}
              placeholder="Enter 10-digit mobile number"
              maxLength="10"
              required
            />
          </div>

          <div className="form-group">
            <label>Email ID *</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Enter your email address"
              required
            />
          </div>

          <div className="form-group">
            <label>Select Course *</label>
            <select
              name="course"
              value={form.course}
              onChange={handleChange}
              required
            >
              <option value="">-- Select Course --</option>
              {courses.map((course, index) => (
                <option key={index} value={course.name}>
                  {course.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Security Question *</label>
            <div className="captcha-container">
              <span className="captcha-question">What is {captcha.question}?</span>
              <input
                type="number"
                name="captchaAnswer"
                value={form.captchaAnswer}
                onChange={handleChange}
                placeholder="Enter answer"
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit Enquiry'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnquiryForm;